module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /Users/charles/Projects/codemix/2016/flow-runtime/~/core-js/library/modules/_add-to-unscopables.js
// module id = 259
// module chunks = 0